import { JSONContent } from '@tiptap/core';

export function collectImageAttachmentIds(
  node: JSONContent | undefined,
): number[] {
  if (!node) {
    return [];
  }
  const ids = new Set<number>();

  walk(node, (n) => {
    if (n.type === 'image') {
      const id = n.attrs?.attachmentId;

      if (typeof id === 'number') {
        ids.add(id);
      }
    }
  });

  return Array.from(ids);
}

//DFS to traverse tiptap json and inject src into image nodes
export function injectImageSrcs(
  node: JSONContent,
  urlsById: Record<number, string>,
): JSONContent {
  return mapTree(node, (n) => {
    if (n.type !== 'image') {
      return n;
    }
    const id = n.attrs?.attachmentId;
    const url = typeof id === 'number' ? urlsById[id] : undefined;

    if (!url) {
      return n;
    }

    return { ...n, attrs: { ...n.attrs, src: url } };
  });
}

/** Load a Blob/File as an <img> and read its natural pixel dimensions. */
export function readImageDimensions(
  blob: Blob,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to read image dimensions'));
    };
    img.src = url;
  });
}

function walk(node: JSONContent, visit: (n: JSONContent) => void): void {
  visit(node);
  node.content?.forEach((child) => walk(child, visit));
}

function mapTree(
  node: JSONContent,
  transform: (n: JSONContent) => JSONContent,
): JSONContent {
  const mapped = transform(node);

  if (!mapped.content) {
    return mapped;
  }

  return {
    ...mapped,
    content: mapped.content.map((child) => mapTree(child, transform)),
  };
}
